import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { getAllZenDeskTagsInArray } from "@faire/help-center-self-serve/utils/zenDeskTags";
import { BRAND_TYPE } from "@faire/help-center-utils/consts/BRAND_TYPE";
import { RETAILER_TYPE } from "@faire/help-center-utils/consts/RETAILER_TYPE";
import { getBrand } from "@faire/help-center-utils/serialized-data/getBrand";
import { getRetailer } from "@faire/help-center-utils/serialized-data/getRetailer";
import { getUser } from "@faire/help-center-utils/serialized-data/getUser";
import uploadAttachment from "@faire/web-api/api/zendesk/uploads/post";
import { ICreateTicketRequest } from "@faire/web-api/com/faire/vendor/zendesk/ICreateTicketRequest";
import { ISO3166Alpha3 } from "@faire/web-api/indigofair/iso3166/ISO3166Alpha3";
import UAParser from "ua-parser-js";
import { orderNumberRegex, weakEmailRegex, weakFaireUrlRegex } from "./regex";
export var validateForm = function validateForm(values, strictLocalize) {
  var errors = {};
  if (values.name.trim().length === 0) {
    errors.name = strictLocalize({
      id: "+vL1KE",
      defaultMessage: [{
        "type": 0,
        "value": "Insira o seu nome completo"
      }]
    });
  }
  if (values.email.trim().length === 0) {
    errors.email = strictLocalize({
      id: "g48jpd",
      defaultMessage: [{
        "type": 0,
        "value": "Insira um endereço de e-mail"
      }]
    });
  } else if (!weakEmailRegex.test(values.email)) {
    errors.email = strictLocalize({
      id: "VDsMV7",
      defaultMessage: [{
        "type": 0,
        "value": "O e-mail deve ser um e-mail válido"
      }]
    });
  }
  if (values.subject.trim().length === 0) {
    errors.subject = strictLocalize({
      id: "T5opeK",
      defaultMessage: [{
        "type": 0,
        "value": "Introduza uma linha de assunto"
      }]
    });
  }
  if (values.description.length === 0) {
    errors.description = strictLocalize({
      id: "Ay3aoN",
      defaultMessage: [{
        "type": 0,
        "value": "Introduza uma descrição"
      }]
    });
  }
  if (values.websiteUrl.trim().length > 0 && !weakFaireUrlRegex.test(values.websiteUrl.trim())) {
    errors.websiteUrl = strictLocalize({
      id: "zK6MFO",
      defaultMessage: [{
        "type": 0,
        "value": "Introduza um URL da Faire válido"
      }]
    });
  }
  return errors;
};
export var uploadAttachmentIfAny = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(attachment) {
    var _response$upload, formData, response;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          if (!attachment) {
            _context.next = 13;
            break;
          }
          _context.prev = 1;
          formData = new FormData();
          formData.append("file", attachment);
          _context.next = 6;
          return uploadAttachment(formData, {
            filename: attachment.name
          });
        case 6:
          response = _context.sent;
          return _context.abrupt("return", (_response$upload = response.upload) === null || _response$upload === void 0 ? void 0 : _response$upload.token);
        case 10:
          _context.prev = 10;
          _context.t0 = _context["catch"](1);
          return _context.abrupt("return", undefined);
        case 13:
          return _context.abrupt("return", undefined);
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[1, 10]]);
  }));
  return function uploadAttachmentIfAny(_x) {
    return _ref.apply(this, arguments);
  };
}();
export var getOrderTokenFromField = function getOrderTokenFromField(selectedBrandOrder, orderNumber) {
  var _selectedBrandOrder$o, _selectedBrandOrder$b, _selectedBrandOrder$b2;
  var orderNumberInput = orderNumber.trim();
  var orderToken = orderNumberInput.toLowerCase() !== (selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : (_selectedBrandOrder$o = selectedBrandOrder.order_number) === null || _selectedBrandOrder$o === void 0 ? void 0 : _selectedBrandOrder$o.toLowerCase()) && orderNumberRegex.test(orderNumberInput.trim()) ? "o_".concat(orderNumberInput.toLowerCase()) : selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : (_selectedBrandOrder$b = selectedBrandOrder.brand_order) === null || _selectedBrandOrder$b === void 0 ? void 0 : (_selectedBrandOrder$b2 = _selectedBrandOrder$b.order_items[0]) === null || _selectedBrandOrder$b2 === void 0 ? void 0 : _selectedBrandOrder$b2.order_token;
  return orderToken;
};
export var getTicketPayload = function getTicketPayload(_ref2) {
  var _ua$browser$name, _ua$os$name, _ua$os$version, _ua$browser$version, _retailer$name, _ref3, _retailer$country, _selectedBrandOrder$b3, _selectedBrandOrder$b4;
  var selectedBrandOrder = _ref2.selectedBrandOrder,
    values = _ref2.values,
    issueType = _ref2.issueType,
    attachmentToken = _ref2.attachmentToken;
  var retailer = getRetailer();
  var brand = getBrand();
  var user = getUser();
  var ua = new UAParser(navigator.userAgent).getResult();
  var platform = (_ua$browser$name = ua.browser.name) !== null && _ua$browser$name !== void 0 ? _ua$browser$name : "";
  var osVersion = "".concat((_ua$os$name = ua.os.name) !== null && _ua$os$name !== void 0 ? _ua$os$name : "", " ").concat((_ua$os$version = ua.os.version) !== null && _ua$os$version !== void 0 ? _ua$os$version : "");
  var appVersion = (_ua$browser$version = ua.browser.version) !== null && _ua$browser$version !== void 0 ? _ua$browser$version : "";
  var customerType = retailer ? RETAILER_TYPE : BRAND_TYPE;
  var businessName = (_retailer$name = retailer === null || retailer === void 0 ? void 0 : retailer.name) !== null && _retailer$name !== void 0 ? _retailer$name : brand === null || brand === void 0 ? void 0 : brand.name;
  var customerBasedIn = (_ref3 = (_retailer$country = retailer === null || retailer === void 0 ? void 0 : retailer.country) !== null && _retailer$country !== void 0 ? _retailer$country : brand === null || brand === void 0 ? void 0 : brand.based_in) !== null && _ref3 !== void 0 ? _ref3 : ISO3166Alpha3.USA;
  var orderToken = getOrderTokenFromField(selectedBrandOrder, values.orderNumber);
  var brandOrderToken = (_selectedBrandOrder$b3 = selectedBrandOrder === null || selectedBrandOrder === void 0 ? void 0 : (_selectedBrandOrder$b4 = selectedBrandOrder.brand_order) === null || _selectedBrandOrder$b4 === void 0 ? void 0 : _selectedBrandOrder$b4.token) !== null && _selectedBrandOrder$b3 !== void 0 ? _selectedBrandOrder$b3 : "";
  var ticketPayload = ICreateTicketRequest.build({
    tags: getAllZenDeskTagsInArray(customerBasedIn !== null && customerBasedIn !== void 0 ? customerBasedIn : "", customerType !== null && customerType !== void 0 ? customerType : "", issueType !== null && issueType !== void 0 ? issueType : ""),
    email: values.email,
    user_name: values.name,
    name: businessName,
    subject: values.subject,
    brand_order_token: brandOrderToken,
    issue_type: issueType,
    description: values.description,
    web_url: values.websiteUrl,
    platform: platform,
    os_version: osVersion,
    app_version: appVersion,
    attachment_token: attachmentToken,
    order_token: orderToken,
    retailer_token: retailer === null || retailer === void 0 ? void 0 : retailer.token,
    brand_token: brand === null || brand === void 0 ? void 0 : brand.token,
    external_id: user === null || user === void 0 ? void 0 : user.token
  });
  return {
    ticketPayload: ticketPayload
  };
};